<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $t('concessionstock') }}</div>
      <router-link
        class="btn-blue"
        to="concession-stock"
      >{{ $t('concessionstock') }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : '' ">{{ $tc('cinema', 1) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema,cinemaIndex) in cinemas"
                  :key="cinemaIndex"
                  href="#"
                  @click="onSelectCinema(cinema)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">{{ errmsg1 }}</span>
            </p>
          </div>
        </div>

        <!-- SELECTED CONCESSION -->
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedConcession.length > 0 ? 'shift-up' : '' ">{{ $t('concession') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedConcession" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in concessionLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectConcessionLevel(Item)"
                >{{ Item.cl_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedConcession.length == 0">{{ errmsg2 }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedRawMaterial.length > 0 ? 'shift-up' : '' "
            >{{ $tc('rawmaterials', 2) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedRawMaterial" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in cinemas_stock"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectRawMaterial(Item)"
                >{{ Item.rm_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedRawMaterial.length == 0">{{ errmsg5 }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedUoM.length > 0 ? 'shift-up' : '' "
            >{{ $tc('unitofmeasurement', 2) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="unable"
                :text="selectedUoM"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in cinemas_stock"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectUom(Item)"
                >{{ Item.uom_unit }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedUoM.length == 0">{{ errmsg4 }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedQuantity > 0 ? 'shift-up' : '' ">{{ $tc('quantity', 2) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedQuantity" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in Quantity"
                  :key="ItemIndex"
                  href="#"
                  @click="OnSelectQuantity(Item)"
                >{{ Item }}</b-dropdown-item>
              </b-dropdown>
              <!-- selectedQuantity = Item;concession_stock.stock_quantity =Item -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedQuantity.length == 0">{{ errmsg3 }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">{{ $t('save') }}</button>
          <button v-on:click="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="concession-stock"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";

export default {
  data() {
    return {
      unable: true,
      isRoleID: true,
      submitted: false,
      errmsg1: "",
      errmsg2: "",
      errmsg3: "",
      errmsg4: "",
      errmsg5: "",
      concession_stock: {
        cinema_id: "",
        stock_id: "",
        cld_level_id: "",
        rm_id: "",
        stock_quantity: "",
        uom_id: ""
      },
      cinemas: [],
      total_quantity: 0,
      concessionLevels: [],
      cinemas_stock: [],
      Quantity: 0,
      selectedCinema: "",
      selectedConcession: "",
      selectedRawMaterial: "",
      selectedQuantity: "",
      selectedUoM: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
  },
  mounted() {},
  methods: {
    getCinemas: function(cine_id) {
      let payload = {
        tableName: "ms_cinemas"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getConcessionLevels: function(cinema_id) {
      this.concessionLevels = [];
      this.selectedConcession = "";
      let payload = {
        tableName: "ms_concession_levels",
        cl_is_active: "Y",
        cinema_id: cinema_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.concessionLevels = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    OnSelectQuantity(Item) {
      console.log("Item ::::", Item);
      this.selectedQuantity = Item;
      this.concession_stock.stock_quantity = Item;
    },
    onSelectCinema: function(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.concession_stock.cinema_id = cinema.cine_id;
      this.getConcessionLevels(cinema.cine_id);
      this.getCinemasStocks(cinema.cine_id);
    },
    getCinemasStocks: function(cine_id) {
      this.cinemas_stock = [];
      let payload = {
        cinema_id: cine_id
      };
      PosFnbService.GetCinemaStocks(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemas_stock = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },

    onSelectConcessionLevel: function(concession) {
      this.selectedConcession = concession.cl_name;
      this.concession_stock.cld_level_id = concession.cl_id;
    },

    onSelectRawMaterial: function(rawmaterial) {
      console.log("rawmaterial :", rawmaterial);

      this.selectedUoM = rawmaterial.uom_unit;
      // this.selectedShort = rawmaterial.uom_unit;

      this.concession_stock.uom_id = rawmaterial.uom_id;
      this.concession_stock[
        "transfered_stock_quantity"
      ] = rawmaterial.transfered_stock_quantity
        ? rawmaterial.transfered_stock_quantity
        : 0;
      this.concession_stock.rm_id = rawmaterial.rm_id;
      this.total_quantity = rawmaterial.stock_quantity;
      if (
        rawmaterial.transfered_stock_quantity &&
        rawmaterial.stock_moved_concession == "N"
      ) {
        this.Quantity =
          rawmaterial.stock_quantity - rawmaterial.transfered_stock_quantity;
      } else if (rawmaterial.stock_moved_concession == "N") {
        this.Quantity = rawmaterial.stock_quantity;
      } else if (rawmaterial.stock_moved_concession == "Y") {
        this.$toasted.show("Stock moved to concession");
        this.Quantity = 0;
      }
      console.log("this.Quantity :", this.Quantity);
      this.selectedRawMaterial =
        rawmaterial.rm_name +
        " " +
        "(" +
        this.Quantity +
        " " +
        rawmaterial.uom_short_form +
        ")";

      this.concession_stock.stock_id = rawmaterial.stock_id;
    },

    onSelectUom: function(uom) {
      this.selectedUoM = uom.uom_unit;
      this.concession_stock.uom_id = uom.uom_id;
    },

    onResetForm: function() {
      this.concession_stock = {
        cinema_id: "",
        stock_id: "",
        cld_level_id: "",
        rm_id: "",
        stock_quantity: "",
        uom_id: ""
      };
    },
    onFinalSubmit: function(flag) {
      this.submitted = true;
      if (this.selectedCinema.length == 0) {
        this.errmsg1 = "Please Select Cinema.";
        return;
      }
      if (this.selectedConcession.length == 0) {
        this.errmsg2 = "Please Select Concession.";
        return;
      }
      if (this.selectedQuantity.length == 0) {
        this.errmsg3 = "Please Select Quantity.";
        return;
      }
      if (this.selectedUoM.length == 0) {
        this.errmsg4 = "Please Select Unit of Measurements.";
        return;
      }
      if (this.selectedRawMaterial.length == 0) {
        this.errmsg5 = "Please Select Raw Material.";
        return;
      } else {
        let payload = {
          ...this.concession_stock,
          total_quantity: this.total_quantity
        };
        PosFnbService.AddConcessionStock(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status) {
              this.onResetForm();
              if (flag) {
                this.$router.push({
                  path: "/fnb/concession-stock"
                });
                this.$toasted.show(data.message);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/ConcessionStockComponents/addConcessionStock.vue